<template>
  <form @submit.prevent="save">
    <vs-card
      id="history-campaign"
      class="flex flex-col justify-between p-5"
      fixedHeight
      style="min-height: 80vh"
    >
      <div class="flex justify-between items-end">
        <div class="flex items-end">
          <h3 class="font-bold">{{ models.name }}</h3>
          <span class="text-primary ml-3 font-bold">{{
            models.tier && models.tier.name
          }}</span>
        </div>
        <div class="history">
          <router-link
            :to="`/${config.uri}/${$route.params.id}`"
            class="font-bold"
          >
            Back to detail
          </router-link>
        </div>
      </div>
      <div class="w-full my-5 flex flex-col lg:flex-row justify-between">
        <div
          class="w-full lg:w-4/12 border-solid border-0 border-grey lg:border-r"
        >
          <div class="field">
            <div class="flex items-center">
              <div class="w-32 h-32 mr-3">
                <img
                  class="h-full w-full object-cover bg-grey rounded-lg"
                  :src="getUrlOfFile(models.image)"
                  alt="image-product"
                />
              </div>
              <div class="description">
                <a class="text-base">{{ models.email }}</a>
                <p class="text-base my-1">
                  Birth date:
                  {{
                    models.bod ? moment(models.bod).format("DD-MMM-YYYY") : "-"
                  }}
                </p>
                <p class="text-base mb-1">{{ contentTypes }}</p>
                <p
                  class="text-base my-1 font-bold"
                  :class="[
                    isVerified === true
                      ? 'text-success'
                      : isVerified === false
                      ? 'text-danger'
                      : 'text-warning',
                  ]"
                >
                  {{ isVerifiedText }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div
          class="w-full lg:w-3/12 flex flex-col justify-evenly border-solid border-0 border-grey lg:border-r my-3 lg:my-0"
        >
          <div class="field">
            <label class="text-base">Address</label>
            <p class="text-base font-bold">
              {{ models.address || "-"
              }}{{ models.province && `, ${models.province}` }}
            </p>
          </div>
          <div class="field">
            <label class="text-base">Phone Number</label>
            <p class="text-base font-bold">{{ models.phoneNumber || "-" }}</p>
          </div>
        </div>
        <div
          class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0 border-solid border-0 border-grey lg:border-r"
        >
          <div class="field">
            <label class="text-base">Date of Joined</label>
            <p class="text-base font-bold">
              {{
                models.dateJoined
                  ? moment(models.dateJoined).format("DD MMMM YYYY")
                  : "-"
              }}
            </p>
          </div>
          <div class="field">
            <label class="text-base">Last Activity</label>
            <p class="text-base font-bold">
              {{
                models.dateJoined
                  ? moment(models.lastActive).format("DD MMMM YYYY HH:mm")
                  : "-"
              }}
            </p>
          </div>
        </div>
        <div class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0">
          <div class="field">
            <label class="text-base">Point Withdraw</label>
            <p class="text-base font-bold">{{ models.totalPoint }}</p>
          </div>
          <div class="field">
            <label class="text-base">Point Balance</label>
            <p class="text-base font-bold">{{ models.totalCash }}</p>
          </div>
        </div>
      </div>

      <vs-divider />

      <div class="w-full flex flex-col lg:flex-row">
        <div
          class="lg:w-1/2 mb-4 lg:mb-0 p-1 overflow-auto"
          style="height: 60vh"
        >
          <div
            v-for="(history, index) in models.histories"
            :key="index"
            class="flex flex-row p-2 border border-solid border-grey rounded-lg mb-3 cursor-pointer h-auto items-center"
            @click="getCampaign(history)"
          >
            <div class="h-32 md:w-48 mr-2 w-1/3">
              <img
                class="h-full w-full object-cover bg-grey rounded-lg"
                :src="history.thumbnail"
                alt="image-product"
              />
            </div>
            <div class="description flex justify-around flex-col h-auto w-2/3">
              <div class="flex items-center">
                <h4 class="w-10/12 truncate">{{ history.title }}</h4>
                <vs-chip
                  :color="
                    history.status_by_duration === 'Active'
                      ? 'success'
                      : 'danger'
                  "
                  class="ml-1"
                >
                  {{ history.status_by_duration }}
                </vs-chip>
              </div>
              <p class="font-medium text-sm">
                {{ moment(history.durationStartDate).format("DD MMMM YYYY") }} -
                {{ moment(history.durationEndDate).format("DD MMMM YYYY") }}
              </p>
              <p class="font-medium text-sm">
                {{ history.campaign_type && history.campaign_type.name }} -
                {{ history.rewardType == "1" ? "Cash" : "Loyalty" }}
              </p>
              <hr class="my-1 mt-2" />
              <div
                class="flex flex-row font-medium"
                v-text="getPlatformHtml(history)"
              ></div>
              <hr class="my-1 mb-2" />
              <span class="font-medium"
                >Your status:
                <span class="font-bold text-sm block">{{
                  history.applies && history.applies.length > 0
                    ? history.applies[0].statusJob
                    : "-"
                }}</span></span
              >
            </div>
          </div>
          <button
            v-if="models.histories.length < config.history.totalData"
            @click="fetchHistories"
            class="block w-full py-3 border-none outline-none bg-transparent cursor-pointer underline"
          >
            Show more
          </button>
        </div>
        <div
          class="lg:w-1/2 m-1 border border-solid border-grey overflow-auto p-5"
          style="height: 60vh"
          v-if="models.activeCampaign"
        >
          <div class="flex justify-center">
            <vs-button
              v-for="(platform, index) in platformList"
              :key="index"
              class="rounded-lg px-3 mx-1 text-sm"
              type="filled"
              :class="{
                'text-primary':
                  platform.id !== config.additional_params.platformId,
              }"
              :color="
                platform.id === config.additional_params.platformId
                  ? 'primary'
                  : '#fff'
              "
              @click="getCampaign(models.activeCampaign, platform.id)"
              >{{ platform.name }}
            </vs-button>
          </div>
          <div class="flex justify-center mt-1 gap-1">
            <vs-button
              v-for="(subplatform, subindex) in subPlatformList"
              :key="subindex"
              class="rounded-lg text-xs w-1/4"
              type="filled"
              :class="{
                'text-primary':
                  subplatform.id !== config.additional_params.subPlatformId,
              }"
              :color="
                subplatform.id === config.additional_params.subPlatformId
                  ? 'primary'
                  : '#fff'
              "
              @click="
                getCampaign(
                  models.activeCampaign,
                  config.additional_params.platformId,
                  subplatform.id
                )
              "
              >{{ subplatform.name }}
            </vs-button>
          </div>
          <div
            v-if="masters.reports && masters.reports.length > 0"
            class="mt-3"
          >
            <div
              v-for="(report, index) in masters.reports"
              :key="report.id ? `${report.id}-${report.linkIndex || 0}` : index"
              class="mb-4"
            >
              <report-card :report="report" />
            </div>
          </div>
          <div
            v-else
            class="flex justify-center items-center"
            style="height: -webkit-fill-available"
          >
            No content found
          </div>
        </div>
      </div>

      <div class="w-full mt-20 flex justify-between flex-col md:flex-row">
        <vs-button
          class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center"
          color="rgb(172,172,172)"
          type="filled"
          @click="$router.go(-1)"
          >Back</vs-button
        >
      </div>
    </vs-card>
  </form>
</template>

<script>
import moment from "moment";
import { getUrlOfFile } from "@/utils/helpers";
import api from "@/utils/api";
import ReportCard from "@/layouts/components/ReportCard.vue";
export default {
  name: "FormUser",
  components: {
    ReportCard,
  },
  data() {
    return {
      getUrlOfFile,
      config: {
        uri: this.$route.meta.link,
        additional_params: {
          campaignId: null,
          platformId: null,
          subPlatformId: null,
          userId: this.$route.params.id,
        },
        history: {
          page: 1,
          totalData: 0,
        },
      },
      models: {
        name: "",
        email: "",
        image: "",
        bod: "",
        contentTypes: [],
        address: "",
        province: "",
        phoneNumber: "",
        dateJoined: "",
        lastActive: "",
        totalCash: "",
        totalPoint: "",
        socialMedia: [],
        isBanned: false,
        isSuspend: false,
        isVerified: null,

        histories: [],
        activeCampaign: null,
      },
      moment,
      masters: {
        reports: [],
      },
    };
  },
  created() {
    this.getDetailAmbassador();
  },
  computed: {
    isVerifiedText() {
      return this.models.isVerified === true
        ? "Approved"
        : this.models.isVerified === false
        ? "Rejected"
        : "Waiting Approval";
    },
    isVerified() {
      return this.models.isVerified;
    },
    contentTypes() {
      return this.models.contentTypes.map((content) => content.name).join(", ");
    },
    platformList() {
      return this.models.activeCampaign &&
        this.models.activeCampaign.platformType
        ? this.models.activeCampaign.platformType
        : [];
    },
    subPlatformList() {
      const hasPlatforms =
        this.platformList &&
        this.platformList.find(
          (platform) => platform.id === this.config.additional_params.platformId
        );
      const baseSubPlatforms =
        hasPlatforms && hasPlatforms.subPlatform
          ? hasPlatforms.subPlatform
          : [];
      const activeCampaign = this.models.activeCampaign;
      if (
        !activeCampaign ||
        !Array.isArray(activeCampaign.subPlatformTypeId) ||
        activeCampaign.subPlatformTypeId.length === 0
      ) {
        return baseSubPlatforms;
      }
      const allowed = new Set(activeCampaign.subPlatformTypeId);
      return baseSubPlatforms.filter((subplatform) =>
        allowed.has(subplatform.id)
      );
    },
  },
  methods: {
    normalizeReports(payload) {
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.data)) return payload.data;
      if (payload && payload.id) return [payload];
      return [];
    },
    fetchHistories() {
      this.config.history.page++;
      this.$axios
        .get(`${api.brandAmbasador}/${this.$route.params.id}/campaign`, {
          params: {
            page: this.config.history.page,
          },
        })
        .then((res) => {
          this.models.histories = [
            ...this.models.histories,
            ...res.data.data.rows,
          ];
          this.config.history.totalData = res.data.data.count;
        });
    },
    getDetailAmbassador() {
      if (this.$route.params.id) {
        const getAmbassador = this.$axios.get(
          `${api.brandAmbasador}/${this.$route.params.id}`
        );
        const getHistory = this.$axios.get(
          `${api.brandAmbasador}/${this.$route.params.id}/campaign`
        );

        Promise.all([getAmbassador, getHistory])
          .then((res) => {
            const { data } = res[0].data;
            this.models.histories = res[1].data.data.rows;
            this.config.history.totalData = res[1].data.data.count;
            this.models.image = data.image;
            this.models.name = data.name;
            this.models.bod = data.bod;
            this.models.email = data.balance.email;
            this.models.socialMedia = data.socialMedia;
            this.models.contentTypes = data.contentTypes;
            this.models.address = data.address;
            this.models.tier = data.tier;
            this.models.province = data.province;
            this.models.phoneNumber = data.balance.phoneNumber;
            this.models.dateJoined = data.balance.dateJoined;
            this.models.lastActive = data.balance.lastActive;
            this.models.totalPoint = data.balance.totalPoint;
            this.models.totalCash = data.balance.totalCash;
            this.models.isVerified = data.isVerified;
            this.models.isSuspend = data.isSuspend;
            this.models.isBanned = data.isBanned;
          })
          .catch(() =>
            this.$router.push({
              name: "page404",
            })
          );
      }
    },

    getCampaign(
      history,
      platformId = history.platformTypeId && history.platformTypeId.length > 0
        ? history.platformTypeId[0]
        : null,
      subPlatformId
    ) {
      if (!platformId || !history.platformTypeId) return;

      const platform = this.$store.state.platforms.find(
        (platform) => platform.id === platformId
      );

      if (!platform) return;

      const platforms =
        history.platformTypeId && history.platformTypeId.length > 0
          ? history.platformTypeId.map((pltfrm) =>
              this.$store.state.platforms.find(
                (platformItem) => platformItem.id === pltfrm
              )
            )
          : [];

      this.config.additional_params.platformId = platformId;
      this.config.additional_params.campaignId = history.id;
      this.models.activeCampaign = {
        ...history,
        platformType: platforms,
      };

      const availableSubPlatforms = this.subPlatformList;
      const resolvedSubPlatformId =
        subPlatformId &&
        availableSubPlatforms.some(
          (subplatform) => subplatform.id === subPlatformId
        )
          ? subPlatformId
          : availableSubPlatforms.length > 0
          ? availableSubPlatforms[0].id
          : null;

      this.config.additional_params.subPlatformId = resolvedSubPlatformId;
      this.masters.reports = [];

      if (!resolvedSubPlatformId) {
        return;
      }

      this.$axios
        .get("/job-content/history", { params: this.config.additional_params })
        .then((res) => {
          this.masters.reports = this.normalizeReports(res.data.data);
        })
        .catch(() => {
          this.masters.reports = [];
        });
    },

    getPlatformHtml(data) {
      return data.platformTypeText && data.platformTypeText.length > 0
        ? data.platformTypeText.join(", ")
        : "-";
    },
  },
};
</script>

<style>
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
</style>
